import axiosClient from './axiosClient';

const tbAuditLogsController = {
    getAuditLogsByEntityId(token, deviceId, startTs, endTs, pageSize = 1000, page = 0) {
        const url = `/api/audit/logs/entity/DEVICE/${deviceId}?pageSize=${pageSize}&page=${page}&sortProperty=createdTime&sortOrder=DESC&startTime=${startTs}&endTime=${endTs}`;
        return axiosClient.get(url, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        });
    },
    getAuditLogs(token, startTs, endTs, pageSize = 1000, page = 0) {
        const url = `/api/audit/logs?pageSize=${pageSize}&page=${page}&sortProperty=createdTime&sortOrder=DESC&startTs=${startTs}&endTs=${endTs}`;
        return axiosClient.get(url, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        });
    },
};

export default tbAuditLogsController;
